export const vipDiscount: Record<string, number> = {
  0: 1,
  1: 0.98,
  2: 0.95,
  3: 0.9,
}

export function getVendorRefreshPrice(count: number) {
  return count ? 500 * Math.pow(2, count - 1) : 0
}
